const BASE_URL = process.env.REACT_APP_BASE_URL;

export const BUSINESS_API_BASE_URL = `${BASE_URL}/api/v1`
